module.exports = __webpack_public_path__ + "static/img/aboutImg3.0ec58982.png";